import type { VisitorPageInput } from "@/lib/graphql/generated/types";

/** BE limits of `VisitorSendMessageInput.page`. */
export const PAGE_URL_MAX = 2048;
export const PAGE_TITLE_MAX = 200;
export const PAGE_REFERRER_MAX = 2048;

export const PAGE_DESCRIPTION_MAX = 500;

export interface RawHostPage {
  url?: string;
  title?: string;
  referrer?: string;
  description?: string;
}

function isHttpUrl(url: string): boolean {
  try {
    const p = new URL(url).protocol;
    return p === "http:" || p === "https:";
  } catch {
    return false;
  }
}

/**
 * The `page` input of a visitor send: the host page url (+ title, referrer) clamped to the BE limits.
 * `undefined` (send no `page` at all) when the url is missing or not http/https.
 */
export function buildVisitorPage(raw: RawHostPage): VisitorPageInput | undefined {
  if (!raw.url || !isHttpUrl(raw.url)) return undefined;
  const title = raw.title?.slice(0, PAGE_TITLE_MAX);
  const referrer = raw.referrer?.slice(0, PAGE_REFERRER_MAX);
  const description = raw.description?.trim().slice(0, PAGE_DESCRIPTION_MAX);
  return {
    url: raw.url.slice(0, PAGE_URL_MAX),
    ...(title ? { title } : {}),
    ...(referrer ? { referrer } : {}),
    ...(description ? { description } : {}),
  };
}
